import BaseModel from "lib/model";
import ContactInformationModel from "models/brand/contact_information";
import { getStore } from "store";

export default BaseModel.extend({
    idAttribute: "ref",
    props: {
        _id: "objectId",
        ref: "objectId",
        role: {
            type: "string",
            values: ["admin", "manager", "rep"],
            required: true,
            default: "rep",
        },
        email: "string",
        name: "string",
        currency_code: {
            type: "string",
            default: () => {
                const store = getStore();
                const { scope } = store.getState();
                return scope.brand?.settings?.currencies[0];
            },
        },
        employee_code: { type: "string", default: "" },
        subteam: {
            type: "string",
            required: true,
            default: "corporate",
        },
        pricing_template: { type: "string", default: "undefined" },
        permissions: { type: "array", required: true },
        last_login: "date",
        assigned_warehouses: {
            type: "array",
            default: () => {
                const store = getStore();
                const { scope } = store.getState();
                const warehouseIds = scope.brand?.settings?.warehouses?.map((warehouse) => {
                    return warehouse._id;
                });

                return warehouseIds;
            },
        },
        hide_full_inventory: { type: "boolean", default: false },
        replacement: { type: "boolean", default: false },
        user_groups: { type: "array", required: true },
    },
    children: {
        contact_information: ContactInformationModel,
    },
    derived: {
        _initials: {
            deps: ["name"],
            fn() {
                const names = this.name.toString().toUpperCase().split(" ");
                let initials = names[0][0];
                if (names[1]) {
                    initials = initials + names[1][0];
                }
                return initials;
            },
        },
    },

    isNew() {
        return false;
    },

    url() {
        if (this.ref) {
            return `/brand/update/user/${this.ref}`;
        } else {
            return `/brand/attach/user/${this.role}`;
        }
    },
});
